import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import WhatsappApiContent from './WhatsappApiContent';

const WhatsappApi = () => (
  <>
    <Helmet>
      <title>WhatsApp API Messaging &amp; Integration for Business | HAWKTRION</title>
      <meta name="description" content="Connect WhatsApp Business API with your apps. Manage messaging, templates, campaigns, CRM workflows, notifications, and automation with HAWKTRION." />
      <meta name="keywords" content="WhatsApp Business API, WhatsApp business messaging, WhatsApp messaging platform" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-api/" />
      <meta property="og:title" content="WhatsApp API Messaging &amp; Integration for Business | HAWKTRION" />
      <meta property="og:description" content="Connect WhatsApp Business API with your apps. Manage messaging, templates, campaigns, CRM workflows, notifications, and automation with HAWKTRION." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-api/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp API Messaging &amp; Integration for Business | HAWKTRION" />
      <meta name="twitter:description" content="Connect WhatsApp Business API with your apps. Manage messaging, templates, campaigns, CRM workflows, notifications, and automation with HAWKTRION." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp API Messaging and Integration for Business" hideCta>
      <WhatsappApiContent />
    </SeoLandingPage>
  </>
);

export default WhatsappApi;